import { c as _c } from "react/compiler-runtime";
// «История просмотра» — макет «Профиль»: сетка 5 колонок (карточки 149, зазор
// 16); на телефоне (кадр 4118:42967) — 2 колонки, по горизонтали 8, по
// вертикали 16. Источник — GET /buyer/view-history (шлюз пишет просмотр сам, когда
// вошедший покупатель открывает карточку товара); цены/скидки/наличие
// досчитываются из витрины (products.byIds), чтобы карточка не расходилась с
// каталогом.

import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";
import { HistoryCard, type HistoryItem } from "@/components/profile/history-card";
import { ProfilePanel } from "@/components/profile/profile-shell";
import { CabinetEmpty } from "@/components/profile/return-parts";
import { useProfile } from "@/store";
export function ProfileHistoryPage() {
  const $ = _c(5);
  const userId = useProfile(_temp);
  let t0;
  if ($[0] !== userId) {
    t0 = {
      queryKey: ["buyer", userId, "view-history"],
      queryFn: _temp5
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const history = useQuery(t0);
  let t1;
  if ($[2] !== history.data || $[3] !== history.isPending) {
    t1 = <ProfilePanel title={"\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430"}>{history.isPending ? <div className="grid grid-cols-2 gap-x-2 gap-y-4 sm:grid-cols-3 sm:gap-x-4 md:grid-cols-4 lg:grid-cols-5">{Array.from({
          length: 10
        }, _temp6)}</div> : (history.data ?? []).length === 0 ? <CabinetEmpty title={"\u0412\u044B \u0435\u0449\u0451 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0441\u043C\u043E\u0442\u0440\u0435\u043B\u0438"} hint={"\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0442\u043E\u0432\u0430\u0440\u044B, \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0432\u044B \u043E\u0442\u043A\u0440\u044B\u0432\u0430\u043B\u0438."} /> : <div className="grid grid-cols-2 gap-x-2 gap-y-4 sm:grid-cols-3 sm:gap-x-4 md:grid-cols-4 lg:grid-cols-5">{(history.data ?? []).map(_temp7)}</div>}</ProfilePanel>;
    $[2] = history.data;
    $[3] = history.isPending;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp7(item) {
  return <HistoryCard key={item.productId} item={item} />;
}
function _temp6(_, i) {
  return <Skeleton key={i} className="aspect-[149/281] rounded-[4px]" />;
}
async function _temp5() {
  const entries = await api.cabinet.viewHistory(50);
  const products = entries.length ? await api.products.byIds(entries.map(_temp2)).catch(_temp3) : [];
  const byId = new Map(products.map(_temp4));
  return entries.map(e_0 => {
    const p_0 = byId.get(e_0.productId);
    return {
      productId: e_0.productId,
      name: p_0?.name ?? e_0.name,
      image: p_0?.photos[0] ?? e_0.image,
      price: p_0?.price ?? e_0.price,
      oldPrice: p_0?.oldPrice,
      product: p_0
    };
  });
}
function _temp4(p) {
  return [p.id, p];
}
function _temp3() {
  return [];
}
function _temp2(e) {
  return e.productId;
}
function _temp(s) {
  return s.user?.id ?? "guest";
}